import { render, staticRenderFns } from "./createAddress.vue?vue&type=template&id=0d4921d4&scoped=true"
import script from "./createAddress.vue?vue&type=script&lang=ts"
export * from "./createAddress.vue?vue&type=script&lang=ts"
import style0 from "./createAddress.vue?vue&type=style&index=0&id=0d4921d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4921d4",
  null
  
)

export default component.exports